<template>
  <li>
    <span :class="['event', eventStatusClass]"></span>
    <router-link :to="eventRouterLink">{{ eventDescription }}</router-link>
  </li>
</template>

<script>
import { helpers } from 'mixins/calendar'

export default {
  mixins: [helpers],

  props: {
    event: {
      required: true,
      type: Object
    }
  }
}
</script>
